import useThemeConfig from "src/themes/useThemeConfig";
import {useTheme} from "styled-components";

export default function useFlowerTypeIndicatorProps(site) {
  const config = useThemeConfig();
  const theme = useTheme();
  return config.options?.flowerType?.getFlowerTypeIndicatorProps?.(site, theme);
}
